<div class="row" *ngIf="propMeta?.pageTitle!=='Login' && propMeta?.pageTitle!=='Applicant Dashboard' && showHeader">
    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <div class="d-flex sub-header " *ngIf="propMeta.pageTitle !== ''" >
            <div class="p-2 mr-auto title" ><a><i (click)="navigateToTable()" *ngIf="propMeta.redirectPath"
                        class="back-icon"></i></a> {{ propMeta.pageTitle }}</div>
                        
        </div>
    </div>
</div>
<div class="bg-white-round m-3 p-3" [ngClass]="propMeta.properties?.formInfo.extraClass">
    <ng-container *ngIf="!isChildForm">
        <!-- [ngClass]="{ 'col-8': propMeta.pageTitle === 'Add User' || propMeta.pageTitle === 'Add location' }" -->
        <form [formGroup]="Form" class="form" >
            <div [class]="propMeta.properties.formInfo.formRowClass" *ngFor="let row of rowNumbers; let i = index">
                <ng-container *ngFor="let field of formControls">
                    <ng-container *ngIf="evaluate(field)">

                        <div class="{{ field.initClass }}" *ngIf="field.rowNumber === i + 1">


                            <sm-input [props]="field" formControlName="{{ field.field_Name }}"
                                *ngIf="field.fieldType === 'input'"
                                (InputAction)="initInputAction($event, field.field_Name)"
                                (input)="validateByUrl(field, field.field_Name, field.validateParams)"></sm-input>

                            <sm-datetimepicker [props]="field" formControlName="{{ field.field_Name }}"
                                (date)="refreshValidation($event, field.refreshValidator, field)"
                                *ngIf="field.fieldType === 'datepicker' || field.fieldType === 'datetimepicker'">
                            </sm-datetimepicker>

                            <!-- <sm-timepicker [props]="field" formControlName="{{ field.field_Name }}"
                            (date)="refreshValidation($event, field.refreshValidator, field)"
                            *ngIf="field.fieldType === 'datetimepicker'">
                        </sm-timepicker> -->

                            <sm-radio [props]="field" formControlName="{{ field.field_Name }}"
                                *ngIf="field.fieldType === 'radio'"
                                (checked)="refreshValidation($event, field.proprefreshValidator, field)"></sm-radio>

                            <sm-checkbox [props]="field" formControlName="{{ field.field_Name }}"
                                *ngIf="field.fieldType === 'checkbox'"
                                (checked)="refreshValidation($event, field.refreshValidator, field)">
                            </sm-checkbox>

                            <app-sm-label [props]="field" 
                            *ngIf="field.fieldType === 'label'"
                            
                            ></app-sm-label>

                            <app-sm-toggle [props]="field" formControlName="{{ field.field_Name }}"
                                *ngIf="field.fieldType === 'toggle'"
                                (checked)="refreshValidation($event, field.refreshValidator, field)">
                            </app-sm-toggle>

                            <sm-textarea [props]="field" formControlName="{{ field.field_Name }}"
                                *ngIf="field.fieldType === 'textarea'"></sm-textarea>

                            <sm-simple-textarea [props]="field" formControlName="{{ field.field_Name }}"
                                *ngIf="field.fieldType === 'SimpleTextarea'"></sm-simple-textarea>

                            <sm-ng-select [props]="field" [options]="field.options"
                                formControlName="{{ field.field_Name }}"
                                (selected)="refreshValidation($event, field.refreshValidator, field)"
                                (filteredState)="initSelect($event, field)"
                                *ngIf="field.fieldType === 'ng-select'"></sm-ng-select>

                                
                            <sm-selectAll [props]="field" [options]="field.options"
                            formControlName="{{ field.field_Name }}"
                            (selected)="refreshValidation($event, field.refreshValidator, field)"
                            (filteredState)="initSelect($event, field)"
                            *ngIf="field.fieldType === 'ng-select'"></sm-selectAll>

                            <sm-select [props]="field" [options]="field.options"
                                formControlName="{{ field.field_Name }}"
                                (selected)="refreshValidation($event, field.refreshValidator, field)"
                                (filteredState)="initSelect($event, field)"
                                *ngIf="field.fieldType === 'select'"></sm-select>

                            <sm-file [props]="field" [Form]="Form" formControlName="{{ field.field_Name }}"
                                [editModel]="{ data: propData, meta: field }"
                                *ngIf="field.fieldType === 'file'"></sm-file>


                            <sm-sub-form [props]="field" formControlName="{{ field.field_Name }}"
                                *ngIf="field.fieldType === 'dynamicform'" [Form]="Form"
                                [EditModel]="propData[field.field_Name]"></sm-sub-form>
                            <sm-multiple-choice [props]="field"
                                *ngIf="field.fieldType === 'singleChoice' || field.fieldType === 'multipleChoice'"></sm-multiple-choice>

                        </div>
                        <!-- <div class="col-12 btn-container d-flex align-items-center justify-content-centre mt-3 px-2">
                        <sm-btn [props]="propMeta.properties.buttons " ></sm-btn>
                    </div> -->


                    </ng-container>
                </ng-container>

            </div>

            <div class="col-12  d-flex align-items-center justify-content-center"
                *ngIf="this.propMeta.properties.buttons">
                <sm-ui-toolbar [btnProps]="propMeta.properties.buttons" [form]="Form" (add)="submitForm()"
                    (res)="resetForm()" [MetaModel]="propMeta"></sm-ui-toolbar>
            </div>
        </form>
    </ng-container>
    <ng-container *ngIf="isChildForm">
        <form [formGroup]="parentForm" class="form">
            <div formGroupName={{propMeta.properties.formInfo.formName}}>
                <div class="row align-items-center" *ngFor="let row of rowNumbers; let i = index">
                    <ng-container *ngFor="let field of formControls">
                        <ng-container *ngIf="evaluate(field)">

                            <div class="{{ field.initClass }}" *ngIf="field.rowNumber === i + 1">


                                <sm-input [props]="field" [formControlName]="field.field_Name"
                                    *ngIf="field.fieldType === 'input'"
                                    (InputAction)="initInputAction($event, field.field_Name)"
                                    (input)="validateByUrl(field, field.field_Name, field.validateParams)"></sm-input>


                                <sm-datetimepicker [props]="field" formControlName="{{ field.field_Name }}"
                                    (date)="refreshValidation($event, field.refreshValidator, field)"
                                    *ngIf="field.fieldType === 'datepicker' || field.fieldType==='datetimepicker'">
                                </sm-datetimepicker>

                                <sm-radio [props]="field" formControlName="{{ field.field_Name }}"
                                    *ngIf="field.fieldType === 'radio'"
                                    (checked)="refreshValidation($event, field.proprefreshValidator, field)"></sm-radio>

                                <sm-checkbox [props]="field" formControlName="{{ field.field_Name }}"
                                    *ngIf="field.fieldType === 'checkbox'"
                                    (checked)="refreshValidation($event, field.refreshValidator, field)">
                                </sm-checkbox>

                                <sm-textarea [props]="field" formControlName="{{ field.field_Name }}"
                                    *ngIf="field.fieldType === 'textarea'"></sm-textarea>



                                <sm-ng-select [props]="field" [options]="field.options"
                                    formControlName="{{ field.field_Name }}"
                                    (selected)="refreshValidation($event, field.refreshValidator, field)"
                                    (filteredState)="initSelect($event, field)"
                                    *ngIf="field.fieldType === 'ng-select'"></sm-ng-select>

                                <sm-select [props]="field" [options]="field.options"
                                    formControlName="{{ field.field_Name }}"
                                    (selected)="refreshValidation($event, field.refreshValidator, field)"
                                    (filteredState)="initSelect($event, field)"
                                    *ngIf="field.fieldType === 'select'"></sm-select>


                                <sm-sub-form [props]="field" formControlName="{{ field.field_Name }}"
                                    *ngIf="field.fieldType === 'dynamicform'" [Form]="Form"
                                    [EditModel]="propData[field.field_Name]"></sm-sub-form>

                            </div>
                            <!-- <div class="col-12 btn-container d-flex align-items-center justify-content-centre mt-3 px-2">
                        <sm-btn [props]="propMeta.properties.buttons " ></sm-btn>
                    </div> -->


                        </ng-container>
                    </ng-container>
                </div>


                <div class="col-12  d-flex align-items-center justify-content-center"
                    *ngIf="this.propMeta.properties.buttons">
                    <sm-ui-toolbar [btnProps]="propMeta.properties.buttons" [form]="Form" (add)="submitForm()"
                        (res)="resetForm()" [MetaModel]="propMeta"></sm-ui-toolbar>
                </div>
            </div>
        </form>
    </ng-container>
</div>